import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.CURIOSO_CALLING;

export const ROUND_COUNT = 2; // The total number of rounds in a given level

// Gameplay
export const LIVES = 3; // Number of failures allowed before being prompted to Try Again

// Stage
export const STAGE_WIDTH = 1024; // Total Stage Width
export const STAGE_HEIGHT = 576; // Total Stage Height
export const BACKGROUND_WIDTH = 2048; // The total width of a given background piece

// The tiling width of this level's FG content
export const WIDTH_FG = {
  LEVEL1: 2048,
  LEVEL2: 3072,
  LEVEL3: 1200,
  LEVEL4: 2500,
  LEVEL5: 1200,
};

// Enumerates the possible world values
export const WORLDS = {
  LEVEL_1: 'level1',
  LEVEL_2: 'level2',
  LEVEL_3: 'level3',
  LEVEL_4: 'level4',
  LEVEL_5: 'level5',
};

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD_VIEW: 'STANDARD_VIEW',
  LOADING: 'LOADING',
};

// Redux Actions
export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  SET_LEVEL: 'SET_LEVEL',
  SET_QUESTION: 'SET_QUESTION',
  MODIFY_LIVES: 'MODIFY_LIVES',
  SET_QUESTION_RESULT: 'SET_QUESTION_RESULT',
  SET_ONBOARDING: 'SET_ONBOARDING',
  INCREMENT_CURRENT_ROUND: 'INCREMENT_CURRENT_ROUND',
};

// Curioso Animation States
export const CURIOSO_ANIMATIONS = {
  IDLE: 'IDLE', // Default state
  QUESTION_RIGHT: 'QUESTION_RIGHT', // Not really used, but could be.
  QUESTION_WRONG: 'QUESTION_WRONG', // Called after a bad answer or automaticity timeout
  WIN: 'WIN', // Level won
  LOSE: 'LOSE', // Level lost
};

// Current game type, used for reporting
export const GAME_TYPE = {
  ONBOARDING: 'onboarding',
  STANDARD: 'standard',
};

// What word type the current question is.
// We always need to have one of these, matches up with
// onboarding too.
export const WORD_TYPE = {
  WORD_VC: 'word_vc', // VC/CVC/CCVC/CVCC word levels
  WORD_COMBINATIONS: 'word_combinations', // Combination levels
  WORD_INFLECTED: 'word_inflected', // Inflected levels
  WORD_PREFIX: 'word_prefix', // Prefixes and Suffixes
  WORD_TWO_SYLLABLE: 'word_two_syllable', // Two Syllable
  WORD_MULTI_SYLLABLE: 'word_multi_syllable', // Multi-syllable
  AUTOMATICITY: 'automaticity', // Automaticity
};

// No Automaticity levels for Curioso Calling
export const AUTOMATICITY_LEVELS = [];
export const AUTOMATICITY_K_LEVELS = [];

// milliseconds before Automaticity timeout
export const AUTOMATICITY_SPEEDS = {
  DEFAULT: 35000,
  MEDIUM: 22500,
  FAST: 17500,
};

// Automaticity state
export const AUTOMATICITY_STATE = {
  NONE: 'none',
  RUNNING: 'running',
  PAUSED: 'paused',
};

// Current game instruction state
export const INSTRUCTION_STATE = {
  UNPLAYED: 'unplayed',
  PLAYING: 'playing',
  PLAYED: 'played',
};

// Current game onboarding state
export const ONBOARD_STATE = {
  NONE: 'none',
  INSTRUCTION: 'instruction',
  HI_TARGET_1: 'hi_target_1',
  HI_TARGET_2: 'hi_target_2',
  HI_TARGET_3: 'hi_target_3',
  HI_DISTRACTOR_1: 'hi_distractor_1',
  HI_DISTRACTOR_2: 'hi_distractor_2',
  HI_DISTRACTOR_3: 'hi_distractor_3',
  ENTRY: 'entry',
};

export const SCROLL_MULTIPLIER = -1; // Negative for opposing scroll direction
export const SCROLL_RATE = 1.2;
